import React from 'react';
import '../template-file-css/document-file-template.css'; 

export const MRRC_BehavioralHealthOutpatient = ({
    itemsRef,
    showErrorFor, 
}) => {

    return (
        <form id='MRRC_BehavioralHealthOutpatient' className='file-pdf-document'>
            <div className='file-template'> 
                <h3>Behavioral Health Crisis Services Treatment Request Form</h3>
                <p className='w-750'>
                    Submit this completed form using our preferred method online at <a href="https://www.availity.com">https://www.availity.com.*</a> 
                </p>
                <p className='w-750'>
                    <strong>Please note: Psychological/neuropsychological testing requests require a separate form.</strong>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Date:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Type of request:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input id="txtDate" name="txtDate" className='add-only' type='date' />
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="chkTypeRequest_InitialReq" name="chkTypeRequest_InitialReq" className='add-only' value="TypeRequest" />Initial request
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Applicable codes:</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="chkApplicable1" name="chkApplicable1" className='add-only' value="Applicable1" />H2011
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="chkApplicable2" name="chkApplicable2" className='add-only' value="Applicable2" />H2011 HK
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="chkApplicable3" name="chkApplicable3" className='add-only' value="Applicable3" />H2011 TG, U8
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="chkApplicable4" name="chkApplicable4" className='add-only' value="Applicable4" />H2011 TG, 95
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="chkApplicable5" name="chkApplicable5" className='add-only' value="Applicable5" />S9484 HK
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="chkApplicable6" name="chkApplicable6" className='add-only' value="Applicable6" />S9484 TG
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="chkApplicable7" name="chkApplicable7" className='add-only' value="Applicable7" />S9485 HK
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="chkApplicable8" name="chkApplicable8" className='add-only' value="Applicable8" />S9485 TG
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" id="chkApplicable9" name="chkApplicable9" className='add-only' value="Applicable9" />S9485 TG, U8
                        </td>
                        <td className='w-150'>&nbsp; </td>
                    </tr>
                </table>
                <h4>Identifying data
                </h4>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Patient's name:</span></td>
                        <td className='w-250'><span className='eleHeader'>Medicaid ID:</span></td>
                        <td className='w-250'><span className='eleHeader'>Date of birth:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtPatientsName" name="txtPatientsName" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtMedicaidId" name="txtMedicaidId" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtDateOfBirth" name="txtDateOfBirth" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Patient's address:</span></td>
                        <td className='w-250'><span className='eleHeader'>City and state:</span></td>
                        <td className='w-250'><span className='eleHeader'>ZIP code:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtPatientAddress" name="txtPatientAddress" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtCityState" name="txtCityState" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtZipCode" name="txtZipCode" className='add-only'  />
                        </td>
                    </tr>
                </table>
                <h4>Provider information
                </h4>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Provider name:</span></td>
                        <td className='w-250'><span className='eleHeader'>NPI:</span></td>
                        <td className='w-250'><span className='eleHeader'>Tax ID:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtProviderName" name="txtProviderName" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtProviderNpiId" name="txtProviderNpiId" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtProviderTaxId" name="txtProviderTaxId" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Phone:</span></td>
                        <td className='w-250'><span className='eleHeader'>Fax:</span></td>
                        <td className='w-250'><span className='eleHeader'>PCP name:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtProviderPhone" name="txtProviderPhone" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtProviderFax" name="txtProviderFax" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtProviderPcp" name="txtProviderPcp" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>PCP NPI:</span></td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtProviderNpi" name="txtProviderNpi" className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Name of other behavioral health providers:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'><strong>1.</strong></td>
                        <td className='w-730'>
                            <input type="text" id="txtNameOfOtherBehavioralHealthProviders_1" name="txtNameOfOtherBehavioralHealthProviders_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'><strong>2.</strong></td>
                        <td className='w-730'>
                            <input type="text" id="txtNameOfOtherBehavioralHealthProviders_2" name="txtNameOfOtherBehavioralHealthProviders_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'><strong>3.</strong></td>
                        <td className='w-730'>
                            <input type="text" id="txtNameOfOtherBehavioralHealthProviders_3" name="txtNameOfOtherBehavioralHealthProviders_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'><strong>4.</strong></td>
                        <td className='w-730'>
                            <input type="text" id="txtNameOfOtherBehavioralHealthProviders_4" name="txtNameOfOtherBehavioralHealthProviders_4" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>DSM-5/ICD-10 diagnoses</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtDsmIcd_11" name="txtDsmIcd_11" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDsmIcd_12" name="txtDsmIcd_12" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDsmIcd_13" name="txtDsmIcd_13" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtDsmIcd_21" name="txtDsmIcd_21" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDsmIcd_22" name="txtDsmIcd_22" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDsmIcd_23" name="txtDsmIcd_23" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Medications</span>
                </p>
                <p className='w-750'>
                    <input type="checkbox" id="chkMedications_1" name="chkMedications_1" className='add-only' value="On7" />Check if member is not adherent to medication regimen.
                </p>
                <p className='w-750'>
                    <input type="checkbox" id="chkMedications_2" name="chkMedications_2" className='add-only' value="On8" />Check if member is not taking any medications.
                </p>
                <p className='w-750'>
                    <textarea id="txtMedications" name="txtMedications" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-350'><span className='eleHeader'>Current medications</span><span className='small'> (indicate changes since last report):</span></td>
                        <td className='w-200'><span className='eleHeader'>Dosage</span></td>
                        <td className='w-200'><span className='eleHeader'>Frequency</span></td>
                    </tr>
                    <tr>
                        <td className='w-350'>
                            <input type="text" id="txtCurrentMedications_1" name="txtCurrentMedications_1" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtDosageRow1" name="txtDosageRow1" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtFrequencyRow1" name="txtFrequencyRow1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>
                            <input type="text" id="txtCurrentMedications_2" name="txtCurrentMedications_2" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtDosageRow2" name="txtDosageRow2" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtFrequencyRow2" name="txtFrequencyRow2" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h4>Current risk factors
                </h4>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Suicide:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="chkSuicide_1" name="chkSuicide_1" className='add-only' value="On9" />None
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="chkSuicide_2" name="chkSuicide_2" className='add-only' value="On10" />Ideation
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="chkSuicide_3" name="chkSuicide_3" className='add-only' value="On11" />Intent without means
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="chkSuicide_4" name="chkSuicide_4" className='add-only' value="On12" />Intent with means
                        </td>
                        <td className='w-750'>
                            <input type="checkbox" id="chkSuicide_5" name="chkSuicide_5" className='add-only' value="On13" />Contracted not to harm self
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Homicide:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="chkHomicide_1" name="chkHomicide_1" className='add-only' value="On14" />None
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="chkHomicide_2" name="chkHomicide_2" className='add-only' value="On15" />Ideation
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="chkHomicide_3" name="chkHomicide_3" className='add-only' value="On16" />Intent without means
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="chkHomicide_4" name="chkHomicide_4" className='add-only' value="On17" />Intent with means
                        </td>
                        <td className='w-750'>
                            <input type="checkbox" id="chkHomicide_5" name="chkHomicide_5" className='add-only' value="On18" />Contracted not to harm others
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Physical or sexual abuse or child/elder neglect:</span>
                    <input type="radio" id="rbPhysicalSexualAbuse_Yes" name="rbPhysicalSexualAbuse" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbPhysicalSexualAbuse_No" name="rbPhysicalSexualAbuse" className='add-only' value="0" /> No
                </p>
                <p className='w-750'>
                    If Yes, patient is:
                </p>
                <table>
                    <tr>
                        <td className='w-100'>
                            <input type="checkbox" id="chkPhysicalSexualAbuseIfYes_1" name="chkPhysicalSexualAbuseIfYes_1" className='add-only' value="On19" />Victim
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="chkPhysicalSexualAbuseIfYes_2" name="chkPhysicalSexualAbuseIfYes_2" className='add-only' value="On20" />Perpetrator
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="chkPhysicalSexualAbuseIfYes_3" name="chkPhysicalSexualAbuseIfYes_3" className='add-only' value="On21" />Both
                        </td>
                        <td className='w-450'>
                            <input type="checkbox" id="chkPhysicalSexualAbuseIfYes_4" name="chkPhysicalSexualAbuseIfYes_4" className='add-only' value="On19" />Neither (but abuse exists in family)
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Abuse or neglect involves a child or elder:</span>
                    <input type="radio" id="rbAbuseInvolvesChild_Yes" name="rbAbuseInvolvesChild" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbAbuseInvolvesChild_No" name="rbAbuseInvolvesChild" className='add-only' value="0" /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Abuse has been legally reported:</span>
                    <input type="radio" id="rbAbuseReported_Yes" name="rbAbuseReported" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbAbuseReported_No" name="rbAbuseReported" className='add-only' value="0" /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Symptoms that are the focus of current treatment</span>
                    <span className='small'>(may include specific testing to support and correlate with DSM diagnoses, observations of behavior or chief complaints)</span>
                    <textarea id="txtSymptomsCurrentTreatment" name="txtSymptomsCurrentTreatment" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Progress since last review</span>
                    <span className='small'>(including what is being re-evaluated or changed, whether member is being reassessed, medication changes, any stressors, or supports that may contribute or serve as a barrier)</span>
                    <textarea id="txtProgressSinceLastReview" name="txtProgressSinceLastReview" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Functional impairments or strengths</span>
                    <span className='small'>(including interpersonal relations, personal hygiene, work/school) - Identify specific behaviors</span>
                    <textarea id="txtFunctionalImpairments" name="txtFunctionalImpairments" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Describe recovery environment</span>
                    <span className='small'>(including support system, level of stress)</span>
                    <textarea id="txtDescribeRecoveryEnvironment" name="txtDescribeRecoveryEnvironment" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Engagement/level of active participation in treatment</span>
                    <textarea id="txtEngagementActiveParticipation" name="txtEngagementActiveParticipation" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Housing</span>
                    <textarea id="txtHousing" name="txtHousing" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Co-occurring medical/physical illness</span>
                    <textarea id="txtCoOccurring" name="txtCoOccurring" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Family history of mental illness or substance use</span>
                    <textarea id="txtFamilyHistory" name="txtFamilyHistory" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Trauma-informed care -</span>
                    Individuals have experienced potentially traumatic events in their lifetime. It is imperative that everyone be aware of the potential impact of trauma on those they serve, be mindful of how their policies and procedures may affect those who use their services, and prepared to recognize and offer trauma-specific services when needed.
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Is there evidence to suggest this member has experienced trauma?</span>
                    <input type="radio" id="rbMemberHasExperiencedTrauma_Yes" name="rbMemberHasExperiencedTrauma" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbMemberHasExperiencedTrauma_No" name="rbMemberHasExperiencedTrauma" className='add-only' value="0" /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What is your plan to assess and address the current and potential effects of that trauma?</span>
                    <textarea id="txtCurrentPotentialEffectsOfThatTrauma" name="txtCurrentPotentialEffectsOfThatTrauma" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <strong>Patient's treatment history including all levels of care:</strong>
                </p>
                <table>
                    <tr>
                        <td className='w-230'><span className='eleHeader'>Level of care</span></td>
                        <td className='w-300'><span className='eleHeader'>Number of distinct episodes/ sessions</span></td>
                        <td className='w-220'><span className='eleHeader'>Date of last episode/ session</span></td>
                    </tr>
                    <tr>
                        <td className='w-230'>Outpatient psych </td>
                        <td className='w-300'>
                            <input type="text" id="txtNumberDistinctEpisodes_1" name="txtNumberDistinctEpisodes_1" className='add-only' />
                        </td>
                        <td className='w-220'>
                            <input type="date" id="txtDateLastEpisode_1" name="txtDateLastEpisode_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-230'>Inpatient psych</td>
                        <td className='w-300'>
                            <input type="text" id="txtNumberDistinctEpisodes_2" name="txtNumberDistinctEpisodes_2" className='add-only' />
                        </td>
                        <td className='w-220'>
                            <input type="date" id="txtDateLastEpisode_2" name="txtDateLastEpisode_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-230'>Outpatient substance use</td>
                        <td className='w-300'>
                            <input type="text" id="txtNumberDistinctEpisodes_3" name="txtNumberDistinctEpisodes_3" className='add-only' />
                        </td>
                        <td className='w-220'>
                            <input type="date" id="txtDateLastEpisode_3" name="txtDateLastEpisode_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-230'>Inpatient substance use</td>
                        <td className='w-300'>
                            <input type="text" id="txtNumberDistinctEpisodes_4" name="txtNumberDistinctEpisodes_4" className='add-only' />
                        </td>
                        <td className='w-220'>
                            <input type="date" id="txtDateLastEpisode_4" name="txtDateLastEpisode_4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-230'>Residential treatment center - Substance use</td>
                        <td className='w-300'>
                            <input type="text" id="txtNumberDistinctEpisodes_5" name="txtNumberDistinctEpisodes_5" className='add-only' />
                        </td>
                        <td className='w-220'>
                            <input type="date" id="txtDateLastEpisode_5" name="txtDateLastEpisode_5" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-230'>Residential treatment center - Psych</td>
                        <td className='w-300'>
                            <input type="text" id="txtNumberDistinctEpisodes_6" name="txtNumberDistinctEpisodes_6" className='add-only' />
                        </td>
                        <td className='w-220'>
                            <input type="date" id="txtDateLastEpisode_6" name="txtDateLastEpisode_6" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <strong>Requested service authorization:</strong>
                </p>
                <table>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>Procedure code </span><span className='small'>(e.g., H2011)</span></td>
                        <td className='w-150'><span className='eleHeader'>Number of units </span><span className='small'>(e.g., 240)</span></td>
                        <td className='w-150'><span className='eleHeader'>Frequency </span><span className='small'>(e.g., 3 times/week)</span></td>
                        <td className='w-150'><span className='eleHeader'>Requested start date </span><span className='small'>(e.g., 3/1/17)</span></td>
                        <td className='w-150'><span className='eleHeader'>Requested end date </span><span className='small'>(e.g., 3/1/17)</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtProcedureCode_1" name="txtProcedureCode_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtNumberUnits_1" name="txtNumberUnits_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_1" name="txtFrequency_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtRequestedStartDate_1" name="txtRequestedStartDate_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtRequestedEndDate_1" name="txtRequestedEndDate_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtProcedureCode_2" name="txtProcedureCode_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtNumberUnits_2" name="txtNumberUnits_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_2" name="txtFrequency_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtRequestedStartDate_2" name="txtRequestedStartDate_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtRequestedEndDate_2" name="txtRequestedEndDate_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtProcedureCode_3" name="txtProcedureCode_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtNumberUnits_3" name="txtNumberUnits_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_3" name="txtFrequency_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtRequestedStartDate_3" name="txtRequestedStartDate_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtRequestedEndDate_3" name="txtRequestedEndDate_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtProcedureCode_4" name="txtProcedureCode_4" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtNumberUnits_4" name="txtNumberUnits_4" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_4" name="txtFrequency_4" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtRequestedStartDate_4" name="txtRequestedStartDate_4" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtRequestedEndDate_4" name="txtRequestedEndDate_4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtProcedureCode_5" name="txtProcedureCode_5" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtNumberUnits_5" name="txtNumberUnits_5" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_5" name="txtFrequency_5" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtRequestedStartDate_5" name="txtRequestedStartDate_5" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtRequestedEndDate_5" name="txtRequestedEndDate_5" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtProcedureCode_6" name="txtProcedureCode_6" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtNumberUnits_6" name="txtNumberUnits_6" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_6" name="txtFrequency_6" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtRequestedStartDate_6" name="txtRequestedStartDate_6" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtRequestedEndDate_6" name="txtRequestedEndDate_6" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtProcedureCode_7" name="txtProcedureCode_7" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtNumberUnits_7" name="txtNumberUnits_7" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_7" name="txtFrequency_7" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtRequestedStartDate_7" name="txtRequestedStartDate_7" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtRequestedEndDate_7" name="txtRequestedEndDate_7" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Treatment goals for each type of service (specify) with expected dates to achieve them</span>
                    <span className='small'>(should correlate with symptoms and DSM diagnoses)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-20'><strong>1.</strong></td>
                        <td className='w-730'>
                            <input type="text" id="txtTreatmentGoals_1" name="txtTreatmentGoals_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'><strong>2.</strong></td>
                        <td className='w-730'>
                            <input type="text" id="txtTreatmentGoals_2" name="txtTreatmentGoals_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'><strong>3.</strong></td>
                        <td className='w-730'>
                            <input type="text" id="txtTreatmentGoals_3" name="txtTreatmentGoals_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'><strong>4.</strong></td>
                        <td className='w-730'>
                            <input type="text" id="txtTreatmentGoals_4" name="txtTreatmentGoals_4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'><strong>5.</strong></td>
                        <td className='w-730'>
                            <input type="text" id="txtTreatmentGoals_5" name="txtTreatmentGoals_5" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Measured objective outcome criteria by which goal achievement is determined</span>
                </p>
                <table>
                    <tr>
                        <td className='w-20'><strong>1.</strong></td>
                        <td className='w-730'>
                            <input type="text" id="txtMeasured_1" name="txtMeasured_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'><strong>2.</strong></td>
                        <td className='w-730'>
                            <input type="text" id="txtMeasured_2" name="txtMeasured_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'><strong>3.</strong></td>
                        <td className='w-730'>
                            <input type="text" id="txtMeasured_3" name="txtMeasured_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'><strong>4.</strong></td>
                        <td className='w-730'>
                            <input type="text" id="txtMeasured_4" name="txtMeasured_4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'><strong>5.</strong></td>
                        <td className='w-730'>
                            <input type="text" id="txtMeasured_5" name="txtMeasured_5" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Discharge plan and estimated discharge date</span>
                    <textarea id="txtDischargePlanDischargeDate" name="txtDischargePlanDischargeDate" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Expected outcome and prognosis:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="chkExpectedOutcomePrognosis_1" name="chkExpectedOutcomePrognosis_1" className='add-only' value="On6" />Return to normal functioning
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="chkExpectedOutcomePrognosis_2" name="chkExpectedOutcomePrognosis_2" className='add-only' value="On5" />Expect improvement, anticipate less than normal functioning
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="chkExpectedOutcomePrognosis_3" name="chkExpectedOutcomePrognosis_3" className='add-only' value="On4" />Relieve acute symptoms, return to baseline functioning
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="chkExpectedOutcomePrognosis_4" name="chkExpectedOutcomePrognosis_4" className='add-only' value="On3" />Maintain current status, prevent deterioration
                        </td>
                    </tr>
                </table>
                <h4>Treatment plan coordination
                </h4>
                <p className='w-750'>
                    <span className='eleHeader'>I have requested permission from the member/member's parent or legal guardian to release information to the PCP.  </span>
                    <input type="radio" id="rbTreatmentPlan_Yes" name="rbTreatmentPlan" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbTreatmentPlan_No" name="rbTreatmentPlan" className='add-only' value="0" /> No
                </p>
                <p className='w-750'>
                    If no, rationale why this is inappropriate:
                    <textarea id="txtTreatmentPlan" name="txtTreatmentPlan" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Treatment plan was discussed with and agreed upon by the member/member's parent or legal guardian:</span>
                    <input type="radio" id="rbTreatmentPlanDiscussedParentLegalGuardian_Yes" name="rbTreatmentPlanDiscussedParentLegalGuardian" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbTreatmentPlanDiscussedParentLegalGuardian_No" name="rbTreatmentPlanDiscussedParentLegalGuardian" className='add-only' value="0" />
                    No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Name of legal guardian (if applicable) and any agencies involved with the member</span>
                    <span className='small'>(Department of Child & Family Services, Office for Citizens with Developmental Disabilities, etc.)</span>
                    <textarea id="txtIncludeTheNameOfLegalGuardian" name="txtIncludeTheNameOfLegalGuardian" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <strong>Please attach summary sheets of ASAM, LOCUS, CASII, CALOCUS or other applicable assessments.</strong>
                </p>
                <table>
                    <tr>
                        <td  className='signature w-550 '>&nbsp;</td>
                        <td  className='signature w-200 '>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-550'>Provider signature:</td>
                        <td className='small w-200'>Date:</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <strong>Disclaimer:</strong>
                    Authorization indicates that Healthy Blue determined medical necessity has been met for the requested service(s) but does not guarantee payment. Payment is contingent upon the eligibility and benefit limitations at the time services are rendered.
                </p>
                <p className='w-750'>
                    <strong>Tips:</strong>
                </p>
                <ul>
                    <li>Healthy Blue accepts additional supporting clinical documentation relevant to authorization requests, such as the Freedom of Choice form, any service plans developed for member (OAD, OCDD, DCFS plans), or latest assessments.
                    </li>
                    <li>When submitting for continued stay, it helps to document severity of illness; specific symptoms of diagnoses; symptoms that treatment is targeting; and how provider plans to address each issue, engagement/motivation or lack of support, functional impairment, etc.
                    </li>
                </ul>






            </div>
        </form>

    )
}























